import svg from "bundle-text:../../../../symbols/space.svg";
import symbols from "../../../../symbols/all";

export default {
  props: {
    icon: String,
    color: String,
  },
  data() {
    return {
      tester: svg,
      symbols,
    };
  },

  methods: {
    setColor() {
      if (this.color) {
        //add to svg
        const symbol = this.$refs.svg;
        if (symbol) {
          symbol.querySelectorAll("g, path").forEach((g) => {
            g.style.fill = this.color;
          });
        }
      }
    },
  },
  mounted() {
    this.setColor();
  },
  updated() {
    this.setColor();
  },
  watch: {
    color() {
      this.setColor();
    },
  },
};
